import ConfirmationDialog from "@Components/app/common/confirmation-dialog";
import { faScrewdriverWrench } from "@fortawesome/pro-solid-svg-icons";
import { useState } from "react";

const MaintenanceBlocker = ({ 
  open, 
  onExit = ()=> {}, 
  isUnityEmbedded = false,
  isSuperAdmin = false
} : { 
  open: boolean, 
  onExit?: () => void, 
  isUnityEmbedded?: boolean,
  isSuperAdmin?: boolean 
}) => {


  const [isOpen, setIsOpen] = useState<boolean>(open);

  return (
    <ConfirmationDialog
      open={isOpen}
      disableCancel={isSuperAdmin ? false : true}
      onCancel={()=> {setIsOpen(false)}}
      iconProps={{
        icon: faScrewdriverWrench,
        size: '6x',
        sx: {
          padding: theme => theme.spacing(3),
          color: theme => theme.palette.dsNeutral.v300
        }
      }}
      disableConfirm={isUnityEmbedded === false}
      title="We're Doing Some Maintenance"
      message="Apologies, but we're in the process updating the BeYourBest platform, so training is currently unavailable."
      confirmLabel='button.exit.app'
      onConfirm={onExit}
    />
  );
};

export default MaintenanceBlocker;